module.exports = __webpack_public_path__ + "media/images/element/02-9bb564573ecde39b89897a11d65bd290.svg";